export default [
    {
        value: '○',
        icon: 'icon-circle',
        en: 'All support by OBD',
        cn: '全部支持通过OBD直接做',
    },
    {
        value: '△',
        icon: 'icon-triangle',
        en: 'Partially support by OBD',
        cn: '部分支持通过OBD直接做'
    },
    {
        value: '□',
        icon: 'icon-rect',
        en: 'All support(Disassembly)',
        cn: '全部支持(拆防盗模块)'
    },
    {
        value: '●',
        icon: 'icon-circle-solid',
        en: 'All support by OBD(Need accessories)',
        cn: '全部支持通过OBD直接做(需要配件)'
    },

    {
        value: '▲',
        icon: 'icon-triangle-solid',
        en: 'Partially support by OBD(Need accessories)',
        cn: '部分支持通过OBD直接做(需要配件)'
    },

    {
        value: '■',
        icon: 'icon-rect-solid',
        en: 'Partially support(Disassembly)',
        cn: '部分支持(拆防盗模块)'
    },
    {
        value: '×',
        icon: 'icon-notsupport',
        en: 'Not support',
        cn: '不支持'
    },
    {
        value: '◎',
        icon: 'icon-circle-double',
        en: 'Conditional support',
        cn: '有条件支持'
    },
    {
        value: '/',
        icon: 'icon-unnecessary',
        en: 'Unnecessary',
        cn: '不需要'
    },
]